import { useTranslation } from "react-i18next";
import {
  PRE_ACTIVATION_FIELD_AVERAGE_PRICE,
  PRE_ACTIVATION_FIELD_IDEAL_CUSTOMER,
  PRE_ACTIVATION_FIELD_WHAT_YOU_SELL,
  PRE_ACTIVATION_FIELD_WHERE_CUSTOMER_BUYS,
  PRE_ACTIVATION_HINT_AVERAGE_PRICE,
  PRE_ACTIVATION_HINT_IDEAL_CUSTOMER,
  PRE_ACTIVATION_HINT_WHAT_YOU_SELL,
  PRE_ACTIVATION_PLACEHOLDER_AVERAGE_PRICE,
  PRE_ACTIVATION_PLACEHOLDER_IDEAL_CUSTOMER,
  PRE_ACTIVATION_PLACEHOLDER_WHAT_YOU_SELL,
} from "../../../i18n/keysTranslations";
import { SALES_CHANNEL_OPTIONS } from "../../../utils/constants";
import { useMemo } from "react";
import { Controller } from "react-hook-form";
import FieldLabel from "../components/FieldLabel";
import FieldError from "../components/FieldError";
import FieldHint from "../components/FieldHint";
import FieldBlock from "../components/FieldBlock";
import CheckGroup from "../components/CheckGroup";
import IntakeTextField from "../../../components/Form/IntakeTextField";
import ReadOnlySectionGrid from "../components/ReadOnlySectionGrid";

const BusinessSection = ({ control, errors, readOnly }) => {
  const { t } = useTranslation();

  const salesChannelOptions = useMemo(
    () =>
      SALES_CHANNEL_OPTIONS.map((o) => ({
        value: o.value,
        label: t(o.labelKey),
      })),
    [t]
  );

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      <FieldBlock>
        <FieldLabel
          htmlFor="whatYouSell"
          text={t(PRE_ACTIVATION_FIELD_WHAT_YOU_SELL)}
          required
        />
        <FieldHint text={t(PRE_ACTIVATION_HINT_WHAT_YOU_SELL)} />
        <IntakeTextField
          name="whatYouSell"
          control={control}
          rules={{}}
          errors={errors}
          fullWidth
          multiline
          minRows={4}
          readOnly={readOnly}
          placeholder={t(PRE_ACTIVATION_PLACEHOLDER_WHAT_YOU_SELL)}
          variant="outlined"
        />
      </FieldBlock>

      <FieldBlock>
        <FieldLabel
          htmlFor="averagePrice"
          text={t(PRE_ACTIVATION_FIELD_AVERAGE_PRICE)}
          required
        />
        <FieldHint text={t(PRE_ACTIVATION_HINT_AVERAGE_PRICE)} />
        <IntakeTextField
          name="averagePrice"
          control={control}
          rules={{}}
          errors={errors}
          fullWidth
          readOnly={readOnly}
          placeholder={t(PRE_ACTIVATION_PLACEHOLDER_AVERAGE_PRICE)}
          variant="outlined"
        />
      </FieldBlock>

      <FieldBlock>
        <FieldLabel
          htmlFor="idealCustomer"
          text={t(PRE_ACTIVATION_FIELD_IDEAL_CUSTOMER)}
          required
        />
        <FieldHint text={t(PRE_ACTIVATION_HINT_IDEAL_CUSTOMER)} />
        <IntakeTextField
          name="idealCustomer"
          control={control}
          rules={{}}
          errors={errors}
          fullWidth
          multiline
          minRows={4}
          readOnly={readOnly}
          placeholder={t(PRE_ACTIVATION_PLACEHOLDER_IDEAL_CUSTOMER)}
          variant="outlined"
        />
      </FieldBlock>

      <FieldBlock>
        <FieldLabel
          htmlFor="whereCustomerBuys"
          text={t(PRE_ACTIVATION_FIELD_WHERE_CUSTOMER_BUYS)}
          required
        />
        <Controller
          name="whereCustomerBuys"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <CheckGroup
                name="whereCustomerBuys"
                options={salesChannelOptions}
                selectedValues={field.value}
                onChange={field.onChange}
                readOnly={readOnly}
              />
              <FieldError message={fieldState.error?.message} />
            </>
          )}
        />
      </FieldBlock>
    </ReadOnlySectionGrid>
  );
};

export default BusinessSection;
